var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHibernate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.536 0l12.31 21.32L13.53 42.67 1.228 21.32z",
    fill: "#59666c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.16.001H13.543l12.31 21.32h24.624z",
    fill: "#bcae79"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.464 64l-12.31-21.32L50.47 21.33 62.772 42.68z",
    fill: "#59666c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.84 63.998h24.62l-12.3-21.32H13.523z",
    fill: "#bcae79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHibernate);
export default __webpack_public_path__ + "static/media/hibernate.998a905e57ce104417e5fc5da4be10a2.svg";
export { ForwardRef as ReactComponent };